import { render, staticRenderFns } from "./roulette-name.vue?vue&type=template&id=3df98bf6&scoped=true&"
import script from "./roulette-name.vue?vue&type=script&lang=js&"
export * from "./roulette-name.vue?vue&type=script&lang=js&"
import style0 from "./roulette-name.vue?vue&type=style&index=0&id=3df98bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df98bf6",
  null
  
)

export default component.exports